/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-01 15:18:12
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-01 15:36:45
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Currency/Components/WarningModal/index.tsx
 */
import React from 'react';
import ReactDOM from 'react-dom';

import { WarningModal } from '@/src/components/Antd';

function showWarningModal({ disabled, onOk, getI18n }) {
  ReactDOM.render(
    <WarningModal
      visible={true}
      header={
        disabled
          ? getI18n('storeCurrency.detail.unabletoDeletecurrency')
          : getI18n('storeCurrency.detail.deletecurrency')
      }
      okText={disabled ? getI18n('general.ok') : getI18n('general.delete')}
      onOk={() => {
        onOk();
        hideWarningModal();
      }}
      onCancel={hideWarningModal}>
      {disabled
        ? getI18n('storeCurrency.detail.tip1')
        : getI18n('storeCurrency.detail.tip2')}
    </WarningModal>,
    document.getElementById('currency-warning-modal'),
  );
}

function hideWarningModal() {
  ReactDOM.unmountComponentAtNode(
    document.getElementById('currency-warning-modal'),
  );
}

export default showWarningModal;
